<template>
  <Modal :id="'cmp-distribution-add_account'" @cancelled="onCancel">
    <template slot="header"> Add Account </template>
    <template slot="body">
      <div class="form-group">
        <TextField
          class="m1"
          :id="'accountName'"
          required
          showValidationIcons
          @validated="onValidation"
          v-bind="textFieldConfig"
          v-model="accountData.account_name"
          isModel
          :placeholder="$t(`account_name`)"
          @valuechanged="onTextFieldValueChange"
        />
        <TextField
          class="m1"
          :id="'shortName'"
          v-bind="textFieldConfig"
          v-model="accountData.short_name"
          isModel
          :showValidationIcons="false"
          :placeholder="$t(`short_name_string`)"
          @valuechanged="onTextFieldValueChange"
        />
        <TextField
          class="m1"
          :id="'account_type'"
          v-bind="textFieldConfig"
          v-model="accountData.account_type"
          isModel
          :showValidationIcons="false"
          :placeholder="$t('account_type')"
          @valuechanged="onTextFieldValueChange"
        />
        <!-- <Dropdown
          :options="accountTypes"
          :selected="selectedAccountTypes"
          :placeholder="'Account Type'"
          :title="'Account Type'"
          multiple
          allnone
          box
          v-on:selectedChange="(e) => onAccounTypeList(e)"
          :listHeight="252"
        /> -->
        <div
          class="ut-flex"
          style="gap: 10px"
        >
          <DTCheckbox
            style="flex: 1"
            :id="'create_credit_note'"
            :label="$t('digital')"
            :checked="accountData.digital"
            @click="(e) => changeCheckbox(e, 'digital')"
            :class="'ml0'"
          />
          <DTCheckbox
            style="flex: 1"
            :id="'invoice_for_zero'"
            :label="$t('physical')"
            :checked="accountData.physical"
            @click="(e) => changeCheckbox(e, 'physical')"            
            :class="'ml0'"
          />
        </div>

        <!-- <div class="checkbox-container">
          <div class="dt-checkbox-control">
            <div class="dt-checkbox v2 s1">
              <input
                tabindex="-1"
                type="checkbox"
                @change="(e) => changeCheckbox(e, 'digital')"
                v-model="accountData.digital"
                name="digital"
                id="digital"
                class="checkbox-input"
              />
              <div tabindex="0" class="checkmark"></div>
            </div>
            <div class="dt-checkbox-label">Digital</div>
          </div>
          <div class="dt-checkbox-control">
            <div class="dt-checkbox v2 s1">
              <input
                tabindex="-1"
                type="checkbox"
                @change="(e) => changeCheckbox(e, 'physical')"
                v-model="accountData.physical"
                name="physical"
                id="physical"
                class="checkbox-input"
              />
              <div tabindex="0" class="checkmark"></div>
            </div>
            <div class="dt-checkbox-label">Physical</div>
          </div>
        </div> -->
        <Dropdown
          class="dt-dropdown m2"
          :options="invoiceProjectTV"
          box
          :placeholder="$t('invoice_project')"
          v-on:selectedChange="(e) => onDropdownChange('invoice_project_id', e)"
          :listHeight="150"
          :selected="
            invoiceProjectTV.find(
              (b) => b.value == accountData.invoice_project_id
            )
          "
        ></Dropdown>
        <Dropdown
          class="dt-dropdown m2"
          :options="currencyTV"
          box
          :placeholder="$t('currency')"
          v-on:selectedChange="(e) => onDropdownChange('currency_id', e)"
          :listHeight="150"
          :selected="currencyTV.find((b) => b.value == accountData.currency_id)"
          showValidationIcons
          required
          immediateValidation
          @validated="(e) => onValidation('currency_id', e)"
        ></Dropdown>
      </div>
    </template>
    <template slot="options">
      <button class="dt-button s6" @click.stop="onCancel">
        {{ $t("cancel") }}
      </button>
      <button
        :disabled="!isFormValid"
        :class="{ disabled: !isFormValid }"
        class="dt-button v1 with-ico s6"
        @click.stop="onAddAccount"
      >
        <div class="button-text">
          {{ $t("ok") }}
        </div>
      </button>
    </template>
  </Modal>
</template>

<script>
import Modal from "@dtplugins/modal/modal";
import { AccountService } from "../../services/account.service";
import { createTV, tv } from "../../../../models/text-value.model";
import { EventHooks } from "../../../../plugins/text-field";
export default {
  components: {
    Modal,
  },
  props: ["accountTypes"],
  data: function () {
    return {
      selectedAccountTypes: [],
      accountData: this.getAccountInfo(),
      unrelated_genre: { genre_id: 1 },
      textFieldConfig: {
        height: 42,
        showEditIconOnHover: false,
        box: true,
        showValidationIcons: true,
        immediateValidation: true,
        validationEvent: EventHooks.OnKeyup,
        isModel: true,
      },
      validationResult: {},
      // Mark: Data
    };
  },
  watch: {},
  mounted: function () {
    this.getAccountFormData();
  },

  computed: {
    isFormValid: function () {
      return Object.values(this.validationResult).every((e) => e.valid);
    },
    // accountEnabled() {
    //   return (
    //     this.accountData.account_name &&
    //     (this.accountData.digital || this.accountData.physical) &&
    //     this.accountData.currency_id
    //   );
    // },
    currencyTV: function () {
      return createTV(
        this.accountData.currencies,
        "currency_iso",
        "currency_id"
      );
    },
    invoiceProjectTV: function () {
      return createTV(
        this.accountData.invoice_projects,
        "invoice_project_name",
        "invoice_project_id"
      );
    },
    // accountTypes: function () {
    //   return [
    //     { text: "Disquaire", value: "Disquaire" },
    //     { text: "Distributor", value: "Distributor" },
    //     { text: "UK Distributor", value: "UK Distributor" },
    //   ];
    // },
  },
  methods: {
    onValidation: function (name, value) {
      this.$set(this.validationResult, name, value);
    },
    getAccountFormData: async function () {
      const result = await AccountService.getNewAccountFormData();
      this.accountData = {
        ...this.accountData,
        ...result.data,
        currency_id: result.data.currencies.find(
          (c) => c.currency_iso === result.data.client.default_currency
        ).currency_id,
      };
    },
    changeCheckbox(e, action) {
      console.log(e.target.checked, action, "::::::::");

      this.accountData[action] = e.target.checked;
      // if (action == "physical") {
      //   this.accountData.digital = false;
      // } else {
      //   this.accountData.physical = false;
      // }
    },
    onTextFieldValueChange: function (name, value) {
      this.accountData[name] = value;
    },
    onCancel: function () {
      this.$emit("cancelled", true);
    },

    onAddAccount: async function () {
      const account = {
        account_name: this.accountData.account_name,
        short_name: this.accountData.short_name,
        account_type: this.accountData.account_type,
        invoice_project_id: this.accountData.invoice_project_id,
        currency_id: this.accountData.currency_id,
        digital: this.accountData.digital ? 1 : 0,
        physical: this.accountData.physical ? 1 : 0,
      };
      const res = await AccountService.addAccount(account);
      this.$emit("added", {
        account_id: res.data.account_id,
        ...account,
      });
    },
    onAccounTypeList: function (value) {
      this.selectedAccountTypes = value;
      this.accountData["account_type"] =
        this.selectedAccountTypes && this.selectedAccountTypes.length > 0
          ? this.selectedAccountTypes.map((e) => e.value).join(",")
          : undefined;
    },
    onDropdownChange(name, value) {
      this.accountData[name] = value.value;
    },
    getAccountInfo: function () {
      return {
        account_name: null,
        short_name: null,
        account_type: null,
        digital: false,
        physical: false,
        invoice_project_id: null,
        currency_id: null,
      };
    },
  },
};
</script>

<style lang="scss">
.cmp-distribution-add_account {
  // .checkbox-container {
  //   display: flex;
  //   flex-direction: row;
  //   justify-content: flex-start;
  //   align-items: center;
  //   margin-top: 10px;
  // }

  // .dt-checkbox-control {
  //   display: flex;
  //   margin: 5px;
  //   height: 25px;
  //   padding-right: 10px;
  //   .dt-checkbox {
  //     padding-top: 5px;
  //   }
  //   .dt-checkbox-label {
  //     padding-left: 5px;
  //   }
  //   .checkmark {
  //     top: 3px;
  //     &:focus-visible,
  //     &:focus {
  //       outline: 1px solid var(--sprt-2) !important;
  //     }
  //   }
  // }
}
</style>